// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyC_6qNNVzMBxY0hzz1cgEvE64Xlw6L0mw4",
  authDomain: "hello-y-ta.firebaseapp.com",
  projectId: "hello-y-ta",
  storageBucket: "hello-y-ta.appspot.com",
  messagingSenderId: "1068914973316",
  appId: "1:1068914973316:web:a4c9cdc96a3893ee6640d1"
};
